"use client";

import { ActivityDisplayPreview } from "./previews";

type RecoveryDisplayProps = {
  data: Record<string, unknown> | null;
  participants: {
    id: string;
    displayName: string;
    avatarUrl: string | null;
    username: string | null;
  }[];
};

export function RecoveryDisplay({ data, participants }: RecoveryDisplayProps) {
  return (
    <ActivityDisplayPreview
      activityId="recovery"
      data={data}
      participants={participants}
    />
  );
}
